import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as GenericEvent from './GenericEvent'
import * as VisitOpening from './VisitOpening'
import * as CollegeVisit from './CollegeVisit'
import { find, includes, get } from 'lodash'

const STATE = {
  OPEN: 'open_state',
  EVENT: 'event_state',
  DRAFT: 'draft_state',
  CLOSED: 'closed_state',
  EXPIRED: 'expired_state',
  DELETED: 'deleted_state',
  PARTIAL_EVENT: 'partial_event_state',
  MIN_ADV_NOTICE_OPEN: 'rep_min_advanced_notice_open_state',
  MIN_ADV_NOTICE_EVENT: 'rep_min_advanced_notice_event_state',
}
const CONFIRMED_VISIT = [STATE.EVENT, STATE.CLOSED, STATE.EXPIRED, STATE.MIN_ADV_NOTICE_EVENT]
const CAN_REGISTER_VISIT = [STATE.OPEN, STATE.PARTIAL_EVENT, STATE.MIN_ADV_NOTICE_OPEN]

export class AbstractCalendarEvent extends React.Component {
  isAttending(event) {
    if (includes(CONFIRMED_VISIT, event.SystemState)) {
      return true
    }
    const participant = find(get(event, 'Participants', []), { Scid: this.props.scid })
    const myRep = find(get(participant, 'Representatives', []), { UserId: this.props.userId })
    return get(myRep, 'SystemState') === 'confirmed_state'
  }

  render() {
    const {
      collegeVisitComponent: CollegeVisitComponent,
      visitOpeningComponent: VisitOpeningComponent,
      genericEventComponent: GenericEventComponent,
    } = this.props
    if (this.isAttending(this.props.event)) {
      return (
        <CollegeVisitComponent
          event={this.props.event}
          onUnregistration={() => this.props.onEventChange()}
          renderDate={this.props.renderDate}
        />
      )
    } else if (includes(CAN_REGISTER_VISIT, this.props.event.SystemState)) {
      return (
        <VisitOpeningComponent
          event={this.props.event}
          onEventChange={() => this.props.onEventChange()}
          renderDate={this.props.renderDate}
        />
      )
    }
    return (
      <GenericEventComponent
        event={this.props.event}
        renderDate={this.props.renderDate}
      />
    )
  }
}

const sharedPropTypes = {
  userId: PropTypes.string.isRequired,
  renderDate: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  onEventChange: PropTypes.func.isRequired,
}

AbstractCalendarEvent.propTypes = {
  ...sharedPropTypes,
  scid: PropTypes.number.isRequired,
  collegeVisitComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  visitOpeningComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  genericEventComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
}

export const PureWeekView = (props) => {
  return (
    <AbstractCalendarEvent
      {...props}
      collegeVisitComponent={CollegeVisit.WeekView}
      visitOpeningComponent={VisitOpening.WeekView}
      genericEventComponent={GenericEvent.WeekView}
    />
  )
}
PureWeekView.propTypes = sharedPropTypes

export const PureMonthView = (props) => {
  return (
    <AbstractCalendarEvent
      {...props}
      collegeVisitComponent={CollegeVisit.MonthView}
      visitOpeningComponent={VisitOpening.MonthView}
      genericEventComponent={GenericEvent.MonthView}
    />
  )
}
PureMonthView.propTypes = sharedPropTypes

const connectFn = (state) => ({
  userId: state.user.record.Id,
  scid: state.user.record.Scid,
})

export const WeekView = connect(connectFn)(PureWeekView)

export const MonthView = connect(connectFn)(PureMonthView)
